export const STREAM_ROUTER_ROOT: string = '/stream';
export const STREAM_ROUTER_NEW: string = `${STREAM_ROUTER_ROOT}/new`;
export const STREAM_ROUTER_UPCOMMING: string = `${STREAM_ROUTER_ROOT}/upcoming`;
export const STREAM_ROUTER_PAST: string = `${STREAM_ROUTER_ROOT}/past`;
export const STREAM_ROUTER_VOD: string = `${STREAM_ROUTER_ROOT}/vod`;
export const VOD_ROUTER_NEW: string = `${STREAM_ROUTER_ROOT}/vod/new`;
export const VOD_ROUTER_EDIT: string = `${STREAM_ROUTER_ROOT}/vod/:id`;
export const STREAM_ROUTER_EDIT: string = `${STREAM_ROUTER_ROOT}/edit/:id`;



// WEBPACK FOOTER //
// ./src/components/Stream/CustomStream/constants.ts